import React, { useState } from 'react';
import SeachStatus from '../../assets/image/search-status.svg';
import './advanceFilter.scss';
import AdvanceFilterSelectInput from './AdvanceFilterSelectInput';
import InputSelect from '../inputSelect/InputSelect';
import Modal from '../modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
	removeSelectedInput,
	setAdvanceFilter,
	setSelectedInput,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { getFiltersParams } from '../../helper';

const AdvanceFilter = ({
	isOpen,
	advanceFilterOptions,
	onFocusSelectedFilterInput,
	onClose,
	onApply,
	modalLabel,
}) => {
	const dispatch = useDispatch();
	const { selectedInputs } = useSelector((state) => state.advanceFilter);
	const [errorCell, setErrorCells] = useState({});

	return (
		<Modal
			title="Advance Filters"
			isOpen={isOpen}
			onClose={onClose}
			cancelButton={true}
			className="advance-filter-modal"
			headerClassName="advance-filter-header"
			titleClassName="fw-bold"
		>
			<div className="d-flex flex-column h-100">
				{/* Note */}
				{modalLabel && (
					<div className="alert alert-info text-center fw-semibold small mb-3">{modalLabel}</div>
				)}

				{/* Scrollable Content */}
				<div className="flex-grow-1 overflow-auto filter-scroll">
					<div className="d-flex flex-column align-items-center gap-3 py-3">
						{/* Search Filter */}
						<div className="filter-search-box d-flex align-items-center gap-2 px-3 py-2 w-100">
							<img
								src={SeachStatus}
								alt="search"
								height="18"
							/>
							<div className="flex-grow-1">
								<InputSelect
									placeholder="Search or Select Filter"
									options={advanceFilterOptions}
									returnInputValue={false}
									autoFocus={true}
									onChange={(value) => {}}
									onSelect={(option) => {
										dispatch(setSelectedInput({ key: option.key, label: option.value }));
									}}
									className="w-100"
								/>
							</div>
						</div>

						{/* Selected Inputs */}
						<div className="w-100">
							{selectedInputs?.map((item) => (
								<div
									key={item?.key}
									className={`border-bottom pb-2 mb-2 ${errorCell[item?.key] ? 'mt-2' : ''}`}
								>
									<AdvanceFilterSelectInput
										label={item?.label}
										options={item?.data}
										returnInputValue={false}
										placeholder={`Select ${item?.label}`}
										value={item?.value}
										autoFocus={true}
										onFocusCb={() => {
											onFocusSelectedFilterInput(item?.key);
										}}
										error={errorCell[item?.key]}
										onSelect={(option) => {
											delete errorCell[item.key];
											dispatch(
												setSelectedInputValue({
													key: item?.key,
													value: option.value,
												}),
											);
										}}
										onChange={(value) => {}}
										removeInput={() => dispatch(removeSelectedInput({ key: item?.key }))}
										className="w-100"
									/>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Footer Buttons */}
				<div className="d-flex justify-content-end gap-3 pt-3 mt-3 border-top">
					<button
						className="cancelButton"
						onClick={onClose}
					>
						Cancel
					</button>

					<button
						disabled={selectedInputs?.length > 0 ? false : true}
						className="applyButton"
						onClick={() => {
							let errors = {};
							if (selectedInputs.length > 0) {
								for (const item of selectedInputs) {
									if (item.value === '' || item.value === null) {
										errors[item.key] = `Select valid ${item.label} from the list`;
									}
								}
							}
							if (Object.keys(errors).length > 0) {
								setErrorCells(errors);
							} else {
								const params = getFiltersParams(selectedInputs);
								dispatch(
									setAdvanceFilter({
										filters: params,
										isAdvanceFilterApplied: true,
									}),
								);
								onApply(params);
							}
						}}
					>
						Apply Filters
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default AdvanceFilter;

{
	/* {Object?.keys(advanceFilterParams.filters)?.map((key) => {
									return (
										<AdvanceFilterSelectInput
											key={key}
											filterKey={key}
											search={search}
											setSearch={setSearch}
											setActiveSearchKey={setActiveSearchKey}
											placeholder={advanceFilterParams.filters[key]}
											label={advanceFilterfilterMap[key]}
											onFocusCb={() => handleFetchAdvanceFilterData(key)}
											onChange={(value) => {
												setAdvanceFilterParams((prev) => ({
													...prev,
													filters: {
														...prev.filters,
														[key]: value[key],
													},
												}));
												setAdvanceFilterSeachKey((prev) => ({
													...prev,
													[key]: value[key],
												}));
											}}
											options={apiResults[key]}
											removeInput={() => {
												const updatedAdvanceFilters = Object.keys(
													advanceFilterParams.filters,
												).reduce((acc, filterKey) => {
													if (filterKey === key) {
														return acc;
													}
													acc[filterKey] = advanceFilterParams.filters[filterKey];
													return acc;
												}, {});
												setAdvanceFilterParams((prev) => ({
													...prev,
													filters: updatedAdvanceFilters,
												}));

												const updatedAdvanceFilterSearchKey = Object.keys(
													advanceFilterSearchKey,
												).reduce((acc, searchKey) => {
													if (searchKey === key) {
														acc[searchKey] = '';
														return acc;
													}
													acc[searchKey] = advanceFilterSearchKey[searchKey];
													return acc;
												}, {});

												setAdvanceFilterSeachKey(updatedAdvanceFilterSearchKey);

												const newSearch = search;
												delete newSearch[key];
												setSearch(newSearch);
											}}
										/>
									);
								})} */
}
